import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M6 4H4v11.451h11.964l-3.176 3.142L14.21 20l5.785-5.723-5.785-5.722-1.422 1.406 3.528 3.49H6V4z" }));
export default createSvgIcon(iconPath, "Paragraph");
//# sourceMappingURL=ParagraphIcon.js.map